export default __webpack_public_path__ + "static/media/product-main-bg.93cd89b9.webp";